import { PollDetails } from 'api/api.types';
import { PartyBarData } from 'lib/PartyBar/partybar.types';
import { excludedPrevParties } from 'utils/transformPoll';

const getPrevListsNotAttending = (
  previousElectionResults: PollDetails,
  listOfPrevIds: number[],
  currentYear: number,
  isBiproportional: boolean,
): PartyBarData[] => {
  const { keyListType, keyComparableId } = isBiproportional
    ? {
        keyListType: 'list_groups',
        keyComparableId: 'party_id',
      }
    : {
        keyListType: 'parties',
        keyComparableId: 'id',
      };

  return previousElectionResults?.[keyListType]
    ?.filter((list) => {
      return (
        !listOfPrevIds.includes(list[keyComparableId]) && list.results.seat_claim > 0
      );
    })
    .map((list) => {
      return {
        title: list.title.de,
        shortTitle: list.short_title.de,
        seatsClaimed: null,
        seatsClaimedPrev: list.results.seat_claim,
        listId: list.id,
        listNumber: 'z', // these lists should be sorted last
        competedInCurrentElection: false,
        competedInPrevElection: true,
      };
    })
    .filter((list) => {
      return !excludedPrevParties.some(
        (exemption) =>
          exemption.yearOfCurrentElection === currentYear &&
          (exemption.listIdPreview === list.listId ||
            exemption.listIdProd === list.listId),
      );
    });
};

export default getPrevListsNotAttending;
